module.exports = __webpack_public_path__ + "static/media/block_user.ddf6f997.svg";